module.exports = __webpack_public_path__ + "static/media/group-3.54ac4d3d.png";